import axios from "axios";
import { useMutation, useQuery } from "react-query";

export function useAddHistoryMutation(options) {
    return useMutation(
        async ({ _id, url }) =>
            await axios.put(`/conversation/${_id}/history`, {
                url,
            }),
        options
    );
}

export function useConversationMessagesQuery(
    conversationId,
    unreadOnly,
    options
) {
    return useQuery(
        ["messages", ...(unreadOnly ? ["unread"] : [])],
        async () =>
            await axios.get(
                `/conversation/${conversationId}/messages${
                    unreadOnly ? "?unread" : ""
                }`
            ),
        options
    );
}

export function useRateConversationMutation(conversationId, options) {
    return useMutation(
        async ({ satisfactionRating }) =>
            await axios.post(`/conversation/${conversationId}/rate`, {
                satisfactionRating,
            }),
        options
    );
}
